export class CeTooltip {
    private _id: string;
    private _container: any;
    private _parent: any;

    constructor(id: string = '', container: any = null, parent: any = null) {
        this._id = id;
        this._container = container;
        this._parent = parent;
    }

    /* Tooltip identifier */
    set id(value: string) {
        if (value) {
            this._id = value;
        } else {
            this._id = '';
        }
    }

    get id(): string {
        return this._id;
    }

    /* Tooltip container element */
    set container(value: any) {
        if (value) {
            this._container = value;
        } else {
            this._container = '';
        }
    }

    get container(): any {
        return this._container;
    }

    /* Tooltip parent element */
    set parent(value: any) {
        if (value) {
            this._parent = value;
        } else {
            this._parent = '';
        }
    }

    get parent(): any {
        return this._parent;
    }

}

export type CeTooltipList = Array<CeTooltip>;

export type CeTooltipData = string | CeTooltipIdLists;
export interface CeTooltipIdLists {
    msIdList: Array<number>;
    bibIdList: Array<number>;
}
export function instanceOfCeTooltipIdLists(object: any): object is CeTooltipIdLists {
    if (typeof object === 'string') {
        return false;
    }
    return 'msIdList' in object && 'bibIdList' in object;
}



// WEBPACK FOOTER //
// ./src/app/models/ce-tooltip.ts